import React, { useState, useEffect } from 'react';
import { Text, View, Pressable, ScrollView, ActivityIndicator, Image } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { colors } from '../utils/colors';
import { styles } from '../utils/styles';
import { StatusBar } from 'expo-status-bar';
import GenreBar from './genre-bar/genre-bar.component';
import EventCard from './event-card/event-card.component';
import { LinearGradient } from 'expo-linear-gradient';
import { MyCarousel } from './carousel/carousel.component';
import { sortGenres, getWelcomeString } from '../utils/helper-functions';

const days = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
const months = ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'];

const HomeScreen = ({ navigation, route }) => {
	const [data, setData] = useState([route.params.newData]);
	const [isLoading, setLoading] = useState(true);
	const [searchTerm, setSearchTerm] = useState('');
	const [genresSearchedFor, setGenresSearchedFor] = useState([]);
	const [fetchedGenres, setFetchedGenres] = useState([]);
	const [mainactState, setMainactState] = useState({});

	const newSearchTerm = (e) => {
		setSearchTerm(e);
	};

	const updateGenreSearch = (genres) => {
		let genreArray = genres.filter((genre) => {
			if (genre.active) {
				return genre.genre;
			}
		});
		setGenresSearchedFor(genreArray);
	};
	useEffect(() => {
		data[0].forEach((datum) => {
			setMainactState[datum.event_id] = false;
		});
		setFetchedGenres(sortGenres(data[0]));
		setLoading(false);
	}, []);

	const filteredEvents = data[0].filter((events) => {
		const collectedGenres = events.flatMap((event) => {
			return event.genres;
		});
		let allGenres = JSON.stringify(collectedGenres);
		// allGenres = allGenres
		// 	.replace(/"/g, '')
		// 	.replace(/[/g, '').replace(/]/g, '')
		// 	.split(',');
		allGenres = allGenres.replace(/"/g, '');
		allGenres = allGenres.replace(/\[/g, '');
		allGenres = allGenres.replace(/\]/g, '').split(',');

		if (genresSearchedFor.length > 0) {
			for (let i = 0; i < genresSearchedFor.length; i++) {
				for (let j = 0; j < allGenres.length; j++) {
					if (allGenres[j].toLowerCase().trim() === genresSearchedFor[i].genre.toLowerCase()) {
						return true;
					}
				}
			}
			return false;
		} else {
			return true;
		}
	});

	const changeMainactState = (eventID) => {
		const newState = Object.assign({}, mainactState);
		newState[eventID] = !newState[eventID];
		setMainactState(newState);
	};

	return (
		<LinearGradient colors={['#252250', '#212529']}>
			<ScrollView style={styles.container}>
				<Text style={styles.marginTopElement}></Text>
				<View style={styles.navigationContainer}>
					<Text style={styles.mainHeading}>{getWelcomeString()}</Text>
					<View style={styles.navigationElements}>
						<Feather name="user" size={26} style={styles.navigation__icon} />
						<Feather name="heart" size={26} style={styles.navigation__icon} />
						<Feather name="settings" size={26} style={styles.navigation__icon} />
					</View>
				</View>
				<GenreBar updateGenreSearch={updateGenreSearch} fetchedGenres={fetchedGenres} />
				{searchTerm === '' && isLoading === false && genresSearchedFor.length === 0 ? (
					<View>
						<Text style={styles.mainHeading}>Anbefalet til dig</Text>
						<MyCarousel events={data} navigation={navigation} />
					</View>
				) : (
					<View></View>
				)}
				{filteredEvents.length === 1 ? <Text style={styles.mainHeading}>{filteredEvents.length} koncert nær dig</Text> : <Text style={styles.mainHeading}>{filteredEvents.length} koncerter nær dig</Text>}

				<View style={styles.events}>
					{isLoading ? (
						<View>
							<Text style={styles.loading__text}>Indlæser koncerter</Text>
							<ActivityIndicator size="large" color="#fa6e42" />
						</View>
					) : (
						filteredEvents.map((customEvents, masterKey) => {
							if (customEvents.length > 1) {
								const eventsHtml = [];
								customEvents.map((customEvent, key) => {
									eventsHtml.push(<EventCard customEvent={customEvent} key={key} navigation={navigation} eventType={'sub'} />);
								});
								const actImages = customEvents.map((customEvent) => customEvent.img_small);
								const mainact = Object.assign({}, customEvents[0]);
								if (customEvents[1].act_type === 'support') {
									mainact.artist = `${mainact.artist} + support`;
								} else {
									mainact.artist = `${mainact.artist} + ${customEvents[1].artist}`;
								}
								mainact.actImages = actImages;
								return (
									<View>
										<EventCard customEvent={mainact} key={masterKey} navigation={navigation} eventType={'container'} changeMainactState={changeMainactState} />
										{mainactState[mainact.event_id] ? eventsHtml : <View></View>}
									</View>
								);
							} else {
								return <EventCard customEvent={customEvents[0]} key={masterKey} navigation={navigation} eventType="main" />;
							}
						})
					)}
				</View>
				<StatusBar style="light" backgroundColor="transparent" />
			</ScrollView>
		</LinearGradient>
	);
};

export default HomeScreen;
